import { render, staticRenderFns } from "./IndexingLabeltem.vue?vue&type=template&id=72b65368&scoped=true&"
import script from "./IndexingLabeltem.vue?vue&type=script&lang=js&"
export * from "./IndexingLabeltem.vue?vue&type=script&lang=js&"
import style0 from "./IndexingLabeltem.vue?vue&type=style&index=0&id=72b65368&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b65368",
  null
  
)

export default component.exports